<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";


export default {
  components: { Layout, PageHeader, },
  page: {
    title: "Ujian Finish",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Ujian Finish",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Student",
          href: "/student",
        },
        {
          text: "Finish Kecermatan",
          active: true,
        },
      ],
    };
  },
  mounted() {
  },
  methods: {
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="container mt-3">
      <b-card no-body>
        <b-card-body
          class="m-3"
          :style="{
            backgroundSize: '125px',
            backgroundImage:
              'url(' + require(`@/assets/logo-shanrise-opc.png`) + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top right',
          }"
        >
          <b-card-title class="text-center">
            <!-- <h3 class="fs-2">Nilai Ujian</h3> -->
          </b-card-title>
          <b-card-body class="text-center">
            <h3>Selamat Nilai Kamu Sedang Dalam Proses, Info Lebih Lanjut Silahkan Hubungi Pihak Terkait.</h3>
          </b-card-body>
        </b-card-body>
      </b-card>
    </div>
  </Layout>
</template>
